module.exports = __webpack_public_path__ + "assets/img/walletBg2.d99f7968.png";